import store from '../../store'
import  stat_data from './index.vue'

window.DASHBOARD=  new Vue({
    store,
    el: '#stat_data',

    data () {
        return {

        }
    },
    created () {

    },
    components : {
        stat_data
    }
});
